import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../../../App.css";
import featuredImage from "../../../assets/PogfortsHome.png";
import titleImage from "../../../assets/TitleHome.png";
import { useAuth } from "../../../context/AuthContext";
import {
    MAX_SEARCH_QUERY_LENGTH,
    buildSearchResultsUrl,
    logBlockedSearchPayload,
    validateSearchQuery,
} from "../../../utils/searchSecurity";

const Home = () => {
    const baseURL = window.location.origin; // This automatically changes for localhost and production
    const navigate = useNavigate();
    const { user } = useAuth();
    const [searchQuery, setSearchQuery] = useState("");
    const [searchError, setSearchError] = useState("");

    const handleSearchSubmit = (event) => {
        event.preventDefault();

        const validation = validateSearchQuery(searchQuery);

        if (!validation.ok) {
            setSearchError(validation.message);

            if (validation.reason === "dangerous_payload") {
                logBlockedSearchPayload({
                    query: searchQuery,
                    reason: validation.reason,
                    userId: user?.id || "guest",
                    source: "home_overlay_search",
                });
            }

            return;
        }

        setSearchError("");
        navigate(buildSearchResultsUrl(validation.value));
    };

    return (
        <div className="home-container">

            {/* SEO Meta Tags for Social Media Sharing */}
            <Helmet>
                <title>Pogforts - MMM Discord Server</title>
                <meta name="description" content="Join Pogforts for an immersive Murder Mystery Magic game experience on Discord!" />
                <meta property="og:title" content="Pogforts - WORLD'S MOST DANGEROUS DISCORD" />
                <meta property="og:description" content="Experience a Discord server game like never before! Join Pogforts for the ultimate experience." />
                <meta property="og:image" content={`${baseURL}/assets/PogfortsHome.png`} />
                <meta property="og:url" content={`${baseURL}/home`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Pogforts - World's Most Dangerous Discord" />
                <meta name="twitter:description" content="Join Pogforts for an immersive Murder Mystery Magic game experience on Discord!" />
                <meta name="twitter:image" content={`${baseURL}/assets/PogfortsHome.png`} />
            </Helmet>

            {/* Hidden H1 Title for SEO but invisible to users */}
            <h1 className="hidden-title">Welcome to Pogforts</h1>

            <img src={titleImage} alt="PogfortsHome" className="featured-image" />
            
            {/* Featured Image Below Title */}
            <div className="home-hero-search-wrap">
                <img src={featuredImage} alt="Pogforts" className="featured-image home-hero-image" />

                <form
                    className="home-search-overlay"
                    aria-label="Search Pogforts public content"
                    onSubmit={handleSearchSubmit}
                >
                    <label className="hidden-title" htmlFor="pogforts-home-search">
                        Search Pogforts
                    </label>
                    <input
                        id="pogforts-home-search"
                        className="home-search-input"
                        type="search"
                        value={searchQuery}
                        maxLength={MAX_SEARCH_QUERY_LENGTH}
                        autoComplete="off"
                        spellCheck="false"
                        placeholder="Search Pogforts"
                        aria-label="Search Pogforts public pages"
                        onChange={(event) => {
                            setSearchQuery(event.target.value);
                            if (searchError) setSearchError("");
                        }}
                    />
                    <button
                        className="home-search-button"
                        type="submit"
                        aria-label="Submit Pogforts search"
                        title="Search Pogforts"
                    >
                        GO
                    </button>
                </form>

                <div className="home-hero-nav-overlay" aria-label="Pogforts content navigation">
                    <Link to="/blog" className="home-hero-nav-button">
                        Blog
                    </Link>
                    <Link to="/news" className="home-hero-nav-button">
                        News
                    </Link>
                </div>
            </div>

            {searchError && (
                <div className="home-search-error" role="alert">
                    {searchError}
                </div>
            )}
        </div>
    );
};

export default Home;
